import * as React from 'react'

import { Box, BoxList, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { WorkSpace } from 'modules/space_control/hooks/useWorkSpace'

import Options from './Options'

interface PropsWorkArea {
  workSpace: WorkSpace
  locationId: number
  workAreaId: number
  isHighlighted?: boolean
  onSelect?: (ws: WorkSpace) => void
}

const WorkSpaceItem = ({
  workSpace,
  locationId,
  workAreaId,
  isHighlighted = false,
  onSelect,
}: PropsWorkArea) => {
  const handleClick = () => {
    if (onSelect) {
      onSelect(workSpace)
    }
  }

  return (
    <Box
      onClick={handleClick}
      cursor="pointer"
      background={isHighlighted ? 'grey100' : 'transparent'}
      border={
        isHighlighted ? { all: { color: 'viridian100', width: 's2', style: 'solid' } } : undefined
      }
      borderRadius={isHighlighted ? { all: 'abs004' } : undefined}
      padding={isHighlighted ? 's8' : undefined}
    >
      <BoxList.Item key={workSpace.id}>
        <Box width="s200">
          <Text.Normal ellipsis size="300" weight="medium" color="grey1000">
            {workSpace.name}
          </Text.Normal>
          <Text.Normal size="200" weight="normal" color="grey800">
            {i18n.tp('settings.locations.location.work_spaces.capacity_count', {
              count: workSpace.capacity,
            })}
          </Text.Normal>
        </Box>
        <Box flexDirection="row" justifyContent="spaceAround" gap="s12">
          <Box alignItems="center" justifyContent="center">
            <Tag type="grey">{workSpace.workSpaceTypeName}</Tag>
          </Box>
          <Options locationId={locationId} workAreaId={workAreaId} workSpace={workSpace} />
        </Box>
      </BoxList.Item>
    </Box>
  )
}

export default observer(WorkSpaceItem)
